import { styled } from 'styled-components';
import Box from '../atoms/Box';

const Filter = styled(Box)`
  height: 54px;
  width: 98%;
  margin: 0 10px;
  margin-bottom: 13px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export default Filter;
